export default __webpack_public_path__ + "img/map-marker.d74985fa.psd";